export default {
      id: "menu__routes_fill-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__routes_fill",
      toString: function () {
        return this.url;
      }
    }